import { render, staticRenderFns } from "./ArticleDomainAdd.vue?vue&type=template&id=58a14752&scoped=true&"
import script from "./ArticleDomainAdd.vue?vue&type=script&lang=js&"
export * from "./ArticleDomainAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a14752",
  null
  
)

export default component.exports